import TextFieldControl from "components/form/TextFieldControl";
import { SCORING_TYPE_TITLE } from "constants/global";

interface PassingThresholdControlProps {
  disabled?: boolean;
  required?: boolean;
}

const PassingThresholdControl = ({ disabled, required = true }: PassingThresholdControlProps) => (
  <TextFieldControl
    name='passingThreshold'
    type='number'
    label={SCORING_TYPE_TITLE.PASSING_THRESHOLD}
    disabled={disabled}
    rules={{
      required,
      min: {
        value: 0,
        message: "Минимальное значение - 0",
      },
      max: {
        value: 100,
        message: "Максимальное значение - 100",
      },
    }}
  />
);

export default PassingThresholdControl;
